export const zoomOptions = "p6a";
export const zoomReset = "q6a";
export const zoomIn = "r6a";
export const zoomOut = "s6a";
export default {zoomOptions,zoomReset,zoomIn,zoomOut};